<template>
    <div class="modal modal_payment" id="modalPayment" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">

                    <h5 class="modal-title title">Выбор способа оплаты</h5>
                    <button type="button" class="btn btn_lg btn_common btn_icononly" data-dismiss="modal"
                        id="paymentClose" ref="paymentClose"><i
                            class="f7-icons icon_lg">xmark</i></button>

                </div>
                <div class="modal-body">

                    <template v-for="(item, index) in items">

                        <div class="row control_item underlined_item">
                            <div class="col-12 col-md-9 col-xl-10 mt_xxs">

                                <div class="media control_group">
                                    <div class="control_action">
                                        <button href="#" class="btn btn_lg btn_common btn_icontext"
                                            @click.prevent="choosePayment(item.id, item.name)">
                                            <i class="f7-icons icon_lg">
                                                {{ payment.id == item.id ? 'checkmark_alt_circle_fill' : 'checkmark_alt_circle' }}
                                            </i>
                                                {{ payment.id == item.id ? 'Выбрано' : 'Выбрать' }}
                                        </button>
                                    </div>

                                    <div class="media-body">
                                        <div class="control_title subtitle">{{ item.name }}</div>

                                        <div v-if="item.description" class="control_info item_info">
                                            <p v-html="item.description"></p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="col-12 col-md-3 col-xl-2 mt_xxs">

                            </div>
                        </div>

                    </template>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        choosePayment(id, name) {
            this.$store.dispatch("order/choosePayment", {id, name});
            document.getElementById("paymentClose").click();
        }
        },
    computed: {
        // Массив методов оплаты
        items() {
            return this.$store.state.payment.payments.filter((value, index) => {

                if (value.is_available_for_pickup === 0 && this.$store.state.order.delivery.type === 'pickup') {
                    return false;
                }

                if (value.is_available_for_delivery === 0 && this.$store.state.order.delivery.type === 'delivery') {
                    return false;
                }

                if (value.is_available_for_point === 0 && this.$store.state.order.delivery.type === 'point') {
                    return false;
                }


                if (value.is_available_for_le === 0 && this.$store.state.order.payer.type === 1) {
                    return false;
                }

                if (value.is_available_for_ie === 0 && this.$store.state.order.payer.type === 2) {
                    return false;
                }
                
                if (value.is_available_for_np === 0 && this.$store.state.order.payer.type === 3) {
                    return false;
                }
                
                return true;
            });
        },

        // Выбранный способ оплаты
        payment() {
            return this.$store.state.order.payment;
        },
    },
};
</script>
